module.exports = __webpack_public_path__ + "media/images/logo_ny-fb2a644e5105fb714f1b3b53fad63d86.svg";